export default __webpack_public_path__ + "img/disabled-checkbox.d85eb93c.svg";